import { render, staticRenderFns } from "./RequirementCategoryView.vue?vue&type=template&id=e91ac33e"
import script from "./RequirementCategoryView.vue?vue&type=script&lang=js"
export * from "./RequirementCategoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports